import React from 'react';

/**
 * Host picks which game to play when the lobby allows more than one.
 * Only live (playable) games can be confirmed; planned games show as coming soon.
 */
function GamePickPanel({
  games = [],
  selectedId,
  onSelect,
  onConfirm,
  floating = false,
}) {
  if (!games.length) return null;

  const panelClass = [
    'spades-bid-panel',
    'spades-game-pick-panel',
    floating ? 'spades-bid-panel--float' : '',
  ].filter(Boolean).join(' ');

  const selected = games.find((g) => g.id === selectedId) || games.find((g) => g.playable);
  const canConfirm = !!(selected && selected.playable);

  return (
    <div className={panelClass} role="dialog" aria-label="Choose game">
      <p className="spades-bid-prompt">Choose the game for this table</p>
      <p className="spades-host-note">
        Only the host picks once. Other seats wait until a game is selected.
      </p>
      <div className="spades-game-pick-list">
        {games.map((g) => {
          const active = selected?.id === g.id;
          return (
            <button
              key={g.id}
              type="button"
              className={[
                'spades-bid-btn',
                'spades-game-pick-btn',
                active ? 'spades-bid-btn--primary' : '',
                !g.playable ? 'spades-game-pick-btn--soon' : '',
              ].filter(Boolean).join(' ')}
              onClick={() => onSelect?.(g.id)}
              disabled={!g.playable && !active}
              title={g.description || g.label}
            >
              {g.label}
              {!g.playable ? ' (soon)' : ''}
            </button>
          );
        })}
      </div>
      <button
        type="button"
        className="spades-bid-btn spades-bid-btn--primary spades-host-btn--wide"
        disabled={!canConfirm}
        onClick={() => canConfirm && onConfirm?.(selected.id)}
      >
        {canConfirm ? `Play ${selected.label}` : 'Select a playable game'}
      </button>
    </div>
  );
}

export default GamePickPanel;
